import { Tabs, Tab } from 'react-bootstrap';
import React, { Component } from 'react';
import Category from './category/category';
import Search from './search/search';
import Favourites from './favourites/favourites';
import './ctcae.css';

class Ctcae extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleSelect = this.handleSelect.bind(this);

        this.state = {
            key: 1
        };
    }

    handleSelect(key) {
        this.setState({ key });
    }

    render() {
        return (
            <div className="ctcae-container">
                <div className="ctcae-title">CTCAE v5</div>
                <div className="tab-container">
                    <Tabs
                        activeKey={this.state.key}
                        onSelect={this.handleSelect}
                        id="tab-list"
                    >
                        <Tab eventKey={1} title="Category">
                            <Category/>
                        </Tab>
                        <Tab eventKey={2} title="Search">
                            <Search/>
                        </Tab>
                        <Tab eventKey={3} title="My favourites">
                            <Favourites/>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        );
    }
}
export default Ctcae;


// WEBPACK FOOTER //
// ./src/component/ctcae5/ctcae.js